import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Router, Event, NavigationEnd } from "@angular/router";
import {UserStorage} from "../../core/storage/user.storage";
import {ObjectsModel} from "../../core/models/objects.model";
import {LayoutService} from "../../core/services/layout.service";
import {OauthService} from '../../core/services/oauth.service';

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit , OnDestroy{
  url: string = "";
  menu: ObjectsModel[] = [];
  opening: number = null;
  isLaptop = true;

  constructor(
    private router: Router,
    public userStorage: UserStorage,
    public layoutService: LayoutService,
    private oauthService: OauthService
  ) {
    this.isLaptop = window.innerWidth > 991.98;
    if (!this.isLaptop) {
      this.layoutService.sidebarOpen$.next(false)
    } else {
      this.layoutService.sidebarOpen$.next(true)
    }
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        $(".main-wrapper").removeClass('slide-nav');
        $(".sidebar-overlay").removeClass('opened');
        this.url = event.url;
        this.findAndOpenCurrentMenu();
      }
    });

    this.oauthService.changeMenu$.subscribe(data => {
      this.ngOnInit();
    })
  }

  toggleMenu(itemEl: HTMLElement, arrow: HTMLElement, objectId: number) {
    this.opening = objectId;
    this.showSubmenu(itemEl, arrow)
  }

  showSubmenu(itemEl: HTMLElement, arrow: HTMLElement) {
    itemEl.classList.toggle("showMenu");
    arrow.classList.toggle("rotate-90");
  }

  submenuClass(objectId: number): any {
    const open = this.layoutService.sidebarOpen$.value;
    const expand = document.body.classList.contains('expand-menu');
    const show = (open || expand) && this.opening == objectId;
    return {
      'frame-menu': true,
      'frame-menu-show': show
    }
  }

  ngOnInit() {
    this.menu = this.userStorage.getUserMenu();
    this.findAndOpenCurrentMenu();
  }

  ngOnDestroy() {
  }

  findAndOpenCurrentMenu(): void {
    this.menu.forEach(menu => {
      if (this.url.includes(menu.url)) {
        this.opening = menu.objectId;
      }
    })
  };

  toggleSidebar(): void {
    this.layoutService.toggleSidebar();
  }

  logout() {
    this.oauthService.logout();
  }
}
